import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {style} from "variables/Variables.jsx";
import NotificationSystem from "react-notification-system";
import {connect}  from  "react-redux";
import {Button, FormGroup, Input, Label} from 'reactstrap';
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities, reactSelectStyles } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import UBCTenderModeFilter from '../../filters/UBCTenderModeFilter.jsx';
import UBCInvoiceRequestFilter from '../../filters/UBCInvoiceRequestFilter.jsx';
import OpenTicketIssueType from '../../filters/OpenTicketIssueType.jsx';
import OpenTicketIssueSubCategory from '../../filters/OpenTicketIssueSubCategory.jsx';
import OpenTicketPriority from '../../filters/OpenTicketPriority.jsx';
import OpenTicketEscalationLevel from '../../filters/OpenTicketEscalationLevel.jsx';
import OpenTicketGenieFlag from '../../filters/OpenTicketGenieFlag.jsx';
import AsoFilter from '../../filters/AsoFilter.jsx';
import MerchantMobile from '../../filters/MerchantMobile.jsx';
import DatePicker from "react-datepicker";
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import MonthPicker from 'react-month-picker';
import MonthBox from "views/MonthBox.jsx";
import "../../assets/css/monthpicker/month-picker.css";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('0', '0', '2020-02-01','0');
var ICICIMonthlyGTVReport='';
var year = new Date().getFullYear();
var mo = new Date().getMonth();
var month_val = '';
if(mo.toString().length==1){
    month_val = "" +0+mo;
}
else {
    month_val = mo;
}

var month_years = "" +month_val+year;
function getLastSixMonths () {
    const now = new Date();
    const months = [];

    for (let i = 0; i < 6; i++) {
        const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // '01', '02', ...
        months.push({ year, month });
    }

    return months;
}
const defaultSelectedMonths = getLastSixMonths();
class ICICIBankingUsersReport extends Component{
    constructor(props) {

        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
           selected_tab:'Monthly CC DC',
           mvalue: [{year: new Date().getFullYear(), month: new Date().getMonth()}],
           m_yr: month_years,
           selectedMonths: defaultSelectedMonths

        }
        this.monthPickerRef = React.createRef();
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this);
        this.handleAMonthChange = this.handleAMonthChange.bind(this);
        this.handleAMonthDissmis = this.handleAMonthDissmis.bind(this);

    }
    formatDate(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${dd}/${mm}/${yyyy}`;
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };


    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, "icici_banking_user_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
            email:decoded.email
        });
    }

    componentDidUpdate() {
     }
    componentDidMount() {
        axios.get(config.get('API_URL')+'/filters/ua-date-config/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => { console.log(response.data)
            const min_date = moment().add(response.data.start_from, 'days').toDate();
            const max_date = moment().add(response.data.end_to, 'days').toDate();
              this.setState({
                min_date: min_date,
                max_date: max_date,

              });
        });

        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.icici_monthly_gtv_report(this.state.object_type,this.state.object_code,'');
        //this.rbl_monthly_returns_report(this.state.object_type,this.state.object_code,'');
        //user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'utid_summary_report','sparcs')
    }

    rbl_monthly_returns_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:"rbl_monthly_returns_report",
            user_id: this.state.user_id,
            selected_months:this.state.selectedMonths
        };
        if ($.fn.DataTable.isDataTable('#RBLMonthlyReturnsReport')) {
            $('#RBLMonthlyReturnsReport').DataTable().clear().destroy();
        }
        var RBLMonthlyReturnsReport = $('#RBLMonthlyReturnsReport').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/rbl_monthly_returns_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data": "Month"},
                    {"data": "CC GTV"},
                    {"data": "CC Count"},
                    {"data": "DC GTV"},
                    {"data": "DC Count"}


                ],
                "columnDefs": [


                ],

            });

    }

    icici_monthly_gtv_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        
        var postData = {
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:"icici_monthly_gtv_report",
            user_id: this.state.user_id,
            selected_months:this.state.selectedMonths
        };
        if ($.fn.DataTable.isDataTable('#ICICIMonthlyGTVReport')) {
            $('#ICICIMonthlyGTVReport').DataTable().clear().destroy();
        }
        var ICICIMonthlyGTVReport = $('#ICICIMonthlyGTVReport').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/icici_monthly_gtv_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data": "Month"},
                    {"data": "Monthly Data (Sale - Refund - CB Lost + CB Won)"},
                    {"data": "Count"}

                ],
                "columnDefs": [

                ],

            });

    }
    icici_monthly_deposits_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:"icici_monthly_deposits_report",
            user_id: this.state.user_id,
            selected_months:this.state.selectedMonths
        };
        if ($.fn.DataTable.isDataTable('#icici_monthly_deposits_report')) {
            $('#icici_monthly_deposits_report').DataTable().clear().destroy();
        }
        var icici_monthly_deposits_report = $('#icici_monthly_deposits_report').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/icici_monthly_deposits_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    { "data": "Month" },
                    { "data": "Payment from various persons towards purchase of goods/services" },
                    { "data": "Pre-funding by merchants/PAs" },
                    { "data": "Transfer representing refunds for transactions" },
                    { "data": "Payment received for onward transfer to merchants" },
                    { "data": "Funds received from the other (ICICI) escrow account" },
                    { "data": "Total of Payins in Table" },
                    { "data": "Total Payin from Escrow" }
                ],
                "columnDefs": [

                ],

            });

    }
    icici_monthly_withdrawals_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:"icici_monthly_withdrawals_report",
            user_id: this.state.user_id,
            selected_months:this.state.selectedMonths
        };
        if ($.fn.DataTable.isDataTable('#icici_monthly_withdrawals_report')) {
            $('#icici_monthly_withdrawals_report').DataTable().clear().destroy();
        }
        var ICICIMonthlyGTVReport = $('#icici_monthly_withdrawals_report').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/icici_monthly_withdrawals_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    { data: "Month" },
                    { data: "Payment to various merchant/service providers" },
                    { data: "Payment to any other account on specific directions"},
                    { data: "Transfers representing refunds transactions to consumers" },
                    { data: "Technical payout failures causing withdrawal entries" },
                    { data: "Payment of commission to the intermediaries" },
                    { data: "Payment of amount received under promotional activities" },
                    { data: "Funds transferred to the other (ICICI) escrow account" },
                    { data: "Total of Payins in Table" },
                    { data: "Total Payin from Escrow" }

                ],
                "columnDefs": [

                ],

            });

    }
    icici_escrow_balance_computation_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:"icici_escrow_balance_computation_report",
            user_id: this.state.user_id,
            selected_months:this.state.selectedMonths
        };
        if ($.fn.DataTable.isDataTable('#icici_escrow_balance_computation_report')) {
            $('#icici_escrow_balance_computation_report').DataTable().clear().destroy();
        }
        var icici_escrow_balance_computation_report = $('#icici_escrow_balance_computation_report').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/icici_escrow_balance_computation_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    { data: "Month" },
                    { data: "Opening Balance" },
                    { data: "Deposits" },
                    { data: "Withdrawals" },
                    { data: "Closing Balance" }
                ],
                "columnDefs": [

                ],

            });

    }
    icici_monthly_gtv_vs_escrow_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:"icici_monthly_gtv_vs_escrow_report",
            user_id: this.state.user_id,
            selected_months:this.state.selectedMonths
        };
        if ($.fn.DataTable.isDataTable('#icici_monthly_gtv_vs_escrow_report')) {
            $('#icici_monthly_gtv_vs_escrow_report').DataTable().clear().destroy();
        }
        var ICICIMonthlyGTVReport = $('#icici_monthly_gtv_vs_escrow_report').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/icici_monthly_gtv_vs_escrow_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    { data: "Month" },
                    { data: "Monthly GTV" },
                    { data: "Escrow Payin" },
                    { data: "GTV - IC Fee - Payin" }
                ],
                "columnDefs": [

                ],

            });

    }

    DownloadCheck(type,e){
        var fn = ''; var url = '';
        var report_code = '';
        if(type==='icici_monthly_gtv_report'){
            fn='icici_monthly_gtv_report.csv.gz';
            url = '/crisp_reports/icici_monthly_gtv_report';
            report_code = "icici_monthly_gtv_report"
        }
        if(type==='icici_monthly_deposits_report'){
            fn='icici_monthly_deposits_report.csv.gz';
            url = '/crisp_reports/icici_monthly_deposits_report';
            report_code = "icici_monthly_deposits_report"
        }
        if(type==='icici_monthly_withdrawals_report'){
            fn='icici_monthly_withdrawals_report.csv.gz';
            url = '/crisp_reports/icici_monthly_withdrawals_report';
            report_code = "icici_monthly_withdrawals_report"
        }
        if(type==='icici_escrow_balance_computation_report'){
            fn='icici_escrow_balance_computation_report.csv.gz';
            url = '/crisp_reports/icici_escrow_balance_computation_report';
            report_code = "icici_escrow_balance_computation_report"
        }
        if(type==='icici_monthly_gtv_vs_escrow_report'){
            fn='icici_monthly_gtv_vs_escrow_report.csv.gz';
            url = '/crisp_reports/icici_monthly_gtv_vs_escrow_report';
            report_code = "icici_monthly_gtv_vs_escrow_report"
        }
//         if(type==='icici_monthly_gtv_vs_escrow_report'){
//             fn='icici_monthly_gtv_vs_escrow_report.csv.gz';
//             url = '/crisp_reports/icici_monthly_gtv_vs_escrow_report';
//             report_code = "icici_monthly_gtv_vs_escrow_report"
//         }
        let filters = {
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            download: 1,
            report_code:report_code,
            user_id: this.state.user_id,
            selected_months:this.state.selectedMonths
        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, url, fn, 60);
    }
   
    reset_all(e){

        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            selectedMonths: []
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }

    get_selected_tab(object_type, object_code, selected_tab, event){
        if(selected_tab==='Monthly Data Sale - Refund - CB Lost - CB Won'){
            this.setState({
                show_acq_issuer: false,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                this.icici_monthly_gtv_report(object_type, object_code, event);
                //this.rbl_monthly_returns_report(object_type, object_code, event);

            }.bind(this), 200);
        }
        if(selected_tab==='Monthly Returns'){
            this.setState({
                show_acq_issuer: true,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                //this.icici_monthly_gtv_report(object_type, object_code, event);
                this.rbl_monthly_returns_report(object_type, object_code, event);

            }.bind(this), 200);
        }
        if(selected_tab==='Deposits into Escrow'){
            this.setState({
                show_acq_issuer: true,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                //this.icici_monthly_gtv_report(object_type, object_code, event);
                this.icici_monthly_deposits_report(object_type, object_code, event);

            }.bind(this), 200);
        }
        if(selected_tab==='Withdrawals from Escrow'){
            this.setState({
                show_acq_issuer: true,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                //this.icici_monthly_gtv_report(object_type, object_code, event);
                this.icici_monthly_withdrawals_report(object_type, object_code, event);

            }.bind(this), 200);
        }
        if(selected_tab==='Balance computation and check'){
            this.setState({
                show_acq_issuer: true,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                //this.icici_monthly_gtv_report(object_type, object_code, event);
                this.icici_escrow_balance_computation_report(object_type, object_code, event);

            }.bind(this), 200);
        }
        if(selected_tab==='Monthly returns matching with Escrow'){
            this.setState({
                show_acq_issuer: true,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                //this.icici_monthly_gtv_report(object_type, object_code, event);
                this.icici_monthly_gtv_vs_escrow_report(object_type, object_code, event);

            }.bind(this), 200);
        }

    }

    handleClickMonthBox (e) {
        this.refs.pickAMonth.show()
    }
    handleAMonthChange(value, text) {
        var month = '';
        if(text.toString().length==1){
            month = "" +0+text;
        }
        else {
            month = text;
        }

        var month_year = "" +month+value;
        this.setState({
            m_yr: month_year,
            mvalue: {year: value, month: text}
        });

    }
    handleAMonthDissmis(value) {
        // this.setState({
        //     mvalue: value
        // });
    }
    makeText = (m) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        if (m && m.year && m.month) {
          return `${months[m.month-1]}. ${m.year}`;
        }
        return '?';
      };
    handleClickMonthBox = (e) => {
        e.preventDefault();
        this.monthPickerRef.current.show();
    };

    handleMonthChange = (year, month) => {
        const formattedMonth = String(month).padStart(2, '0');
        const newMonth = {
            year,
            month: formattedMonth
        };
        this.setState({
            isChange: true
        });
        this.setState(prevState => {
            const exists = prevState.selectedMonths.some(
                m => m.year === year && m.month === formattedMonth
            );
            if (exists) {
                return {
                    selectedMonths: prevState.selectedMonths.filter(
                        m => !(m.year === year && m.month === formattedMonth)
                    )
                };
            } else {
                return {
                    selectedMonths: [...prevState.selectedMonths, newMonth]
                };
            }
        });
    };
    render() {
        const { selectedMonths } = this.state;
        const pickerLang = {
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        };
        console.log(selectedMonths)
        return(
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
{/*                                 <div className="col-md-9 no-padd"> */}
{/*                                     <div className="header"> */}
{/*                                         <h4 className="title">Urgent tickets assignment</h4> */}
{/*                                         <p className="category"></p> */}
{/*                                     </div> */}
{/*                                 </div> */}
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                        <div className="col-md-4 filter-bottom5 padd-5 date-icon-small">
                                            <div style={{ marginBottom: '0px' }}>
                                              <div
                                                onClick={this.handleClickMonthBox}
                                                style={{
                                                  padding: '5px',
                                                  border: '1px solid #ddd',
                                                  borderRadius: '4px',
                                                  cursor: 'pointer',
                                                  minHeight: '20px',
                                                  background: '#ffffff',
                                                  fontSize: '12px'
                                                }}
                                              >
                                                {selectedMonths.length > 0
                                                  ? selectedMonths.map(this.makeText).join(' | ')
                                                  : 'All months...'}
                                              </div>
                                            </div>

                                            <MonthPicker
                                              ref={this.monthPickerRef}
                                              lang={pickerLang.months}
                                              years={{
                                                min: { year: 2016, month: 1 },
                                                max: {
                                                  year: new Date().getFullYear(),
                                                  month: new Date().getMonth() + 1
                                                }
                                              }}
                                              value={selectedMonths}
                                              onChange={this.handleMonthChange}
                                              theme="light"
                                            />
                                        </div>
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_selected_tab.bind(this, this.state.object_type,this.state.object_code, this.state.selected_tab)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="row">

                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0 usertab">
                                        <Tabs>
                                            <TabList>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Monthly Data Sale - Refund - CB Lost - CB Won','')}>Monthly Data (Sale - Refund - CB Lost + CB Won)</Tab>
{/*                                                 <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Monthly Returns','')}>Monthly Returns</Tab> */}
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Deposits into Escrow','')}>Deposits into Escrow</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Withdrawals from Escrow','')}>Withdrawals from Escrow</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Balance computation and check','')}>Balance computation and check</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Monthly returns matching with Escrow','')}>Monthly returns matching with Escrow</Tab>
                                            </TabList>

                                            <TabPanel>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.DownloadCheck.bind(this, 'icici_monthly_gtv_report')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="ICICIMonthlyGTVReport" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Month</th>
                                                            <th>Monthly Data (Sale - Refund - CB Lost + CB Won)</th>
                                                            <th>Count</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                            </table>
                                            </div>
                                         </TabPanel>
{/*                                          <TabPanel> */}
{/*                                                 <div className="content-tdetails-table table-full-width table-responsive marginTop0"> */}
{/*                                                 <div className=""> */}
{/*                                                     <a href="#" className="exportButton" role="button" onClick={this.DownloadCheck.bind(this, 'rbl_monthly_returns_report')}> */}
{/*                                                         <i className="fa fa-download" aria-hidden="true"></i> */}
{/*                                                         Export to CSV */}
{/*                                                     </a> */}
{/*                                                 </div> */}
{/*                                                 <table id="RBLMonthlyReturnsReport" className="table table-striped table-hover"> */}
{/*                                                     <thead> */}
{/*                                                         <tr> */}
{/*                                                             <th>Month</th> */}
{/*                                                             <th>CC GTV</th> */}
{/*                                                             <th>CC Interchange</th> */}
{/*                                                             <th>CC Count</th> */}
{/*                                                             <th>DC GTV</th> */}
{/*                                                             <th>DC Interchange</th> */}
{/*                                                             <th>DC Count</th> */}
{/*                                                         </tr> */}
{/*                                                     </thead> */}
{/*                                                     <tbody> */}

{/*                                                     </tbody> */}
{/*                                             </table> */}
{/*                                             </div> */}
{/*                                          </TabPanel> */}
                                         <TabPanel>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.DownloadCheck.bind(this, 'icici_monthly_deposits_report')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="icici_monthly_deposits_report" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Month</th>
                                                            <th>Payment from various persons towards purchase of goods/services</th>
                                                            <th>Pre-funding by merchants/PAs</th>
                                                            <th>Transfer representing refunds for failed/disputed/returned/cancelled transactions</th>
                                                            <th>Payment received for onward transfer to merchants under promotional activities, incentives, cashbacks etc</th>
                                                            <th>Funds received from the other (ICICI) escrow account</th>
                                                            <th>Total of Payins in Table</th>
                                                            <th>Total Payin from Escrow</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                            </table>
                                            </div>
                                         </TabPanel>
                                         <TabPanel>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.DownloadCheck.bind(this, 'icici_monthly_withdrawals_report')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="icici_monthly_withdrawals_report" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Month</th>
                                                            <th>Payment to various merchant/service providers</th>
                                                            <th>Payment to any other account on specific directions from the merchant</th>
                                                            <th>Transfers representing refunds for failed/disputed transactions  to consumers</th>
                                                            <th>Technical payout failures causing withdrawal entries</th>
                                                            <th>Payment of commission to the intermediaries</th>
                                                            <th>Payment of amount received under promotional activities, incentives, cashbacks, etc.</th>
                                                            <th>Funds transferred to the other (ICICI) escrow account</th>
                                                            <th>Total of Payins in Table</th>
                                                            <th>Total Payin from Escrow</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                            </table>
                                            </div>
                                         </TabPanel>
                                         <TabPanel>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.DownloadCheck.bind(this, 'icici_escrow_balance_computation_report')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="icici_escrow_balance_computation_report" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Month</th>
                                                            <th>Opening Balance</th>
                                                            <th>Deposits</th>
                                                            <th>Withdrawals</th>
                                                            <th>Closing Balance</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                            </table>
                                            </div>
                                         </TabPanel>
                                         <TabPanel>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.DownloadCheck.bind(this, 'icici_monthly_gtv_vs_escrow_report')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="icici_monthly_gtv_vs_escrow_report" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Month</th>
                                                            <th>Monthly GTV</th>
                                                            <th>Escrow Payin</th>
                                                            <th>GTV - IC Fee - Payin</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                            </table>
                                            </div>
                                         </TabPanel>
                                       </Tabs>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
           
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( ICICIBankingUsersReport );